<template>
  <HoverMenu v-if="id" :nudgeamount="-3" :disabled="true || !CustomerGroup">
    <template v-slot:menu-activator>
      <AreaLi :label="$t('servicesystem.common_objects.customer.group')" :value="CustomerGroup ? CustomerGroup.Name : ''"
        :loading="loading">
        <template v-slot:value>
          <div v-if="loading">
            <v-skeleton-loader class="ml-3" type="text" height="28" width="30%">
            </v-skeleton-loader>
          </div>
          <a v-else-if="CustomerGroup"
            :href="getRoute({ page: 'ViewCustomerGroup', params: { customerGroupId: CustomerGroup.Id }, guiver: 'old', travel: false })"
            class="d-flex px-3 pb-2 text-decoration-none">
            <v-icon size="16" class="mr-2" :color="color" v-text="'$customer_group'" />
            <v-list-item-title v-text="CustomerGroup ? (CustomerGroup.Id + ' ' + CustomerGroup.Name) : ''"
              :class="[(color + '--text'), 'nowrapheader']" style="font-size: 17px !important;" />
          </a>
          <div v-else class="px-3 pb-2 error--text">
            {{ $t('servicesystem.common_objects.fallbackterms.failed_to_get') }}
          </div>
        </template>
      </AreaLi>
    </template>

    <template v-slot:menu-content>
      <v-progress-circular v-if="loading" indeterminate color="primary">
      </v-progress-circular>
      <v-container v-else-if="!loading && CustomerGroup" class="pa-0" fluid>
        <v-row no-gutters>
          <v-col cols="3">
            kunde 123
          </v-col>
        </v-row>
      </v-container>
    </template>
  </HoverMenu>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import AreaLi from "@/components/Inputs/AreaListItem.vue";
import HoverMenu from "@/components/Menus/HoverMenu.vue";

export default {
  name: "CustomerGroupCard",
  props: ["id"],
  components: {
    AreaLi,
    HoverMenu,
  },
  mixins: [clientAPI],

  data() {
    return {
      CustomerGroup: null,
      loading: false,
    };
  },

  mounted() {
    this.getCustomerGroup();
  },

  methods: {
    getCustomerGroup() {
      if (this.id) {
        this.loading = true;
        this.getCustomerGroupById(this.id)
          .then((response) => {
            this.CustomerGroup = response;
          })
          .catch((exception) => {
            console.error(exception);
            this.CustomerGroup = null;
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.CustomerGroup = null;
      }
    },
  },

  computed: {
    color() {
      if (this.CustomerGroup) {
        return this.CustomerGroup.IsActive ? "primary" : "disabled";
      } else {
        return "";
      }
    },
  },

  watch: {
    id: function () {
      this.getCustomerGroup();
    },
  },
};
</script>

<style lang="scss"></style>